import * as React from "react";
import { CardDetailsParams } from "../../../../../typings/CardDetailsParams";
import { renderGameStateWrapper, renderTeamsWrapper, renderLiveDetails, renderPreliveDetails, renderIconsWrapper } from "../RenderMethods";

export const renderEventCardDetails = (props: CardDetailsParams, componentPrefix: string) => {
    const event = props.event;
    const noLeague = props.showLeagueInEventCard ? "" : `rj-ev-list__${componentPrefix}__section-item--no-league`;
    const inKickOff = event.isInKickOffState ? `rj-ev-list__${componentPrefix}__section-item--in-kick-off` : "";
    const classNames = `rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__event-info ${noLeague} ${inKickOff}`;

    return (
        <a href={event.linkUrl}
            onClick={props.handlers.eventCard}
            className={`${classNames} `}
            key={`${componentPrefix}__event-info__${event.id}`}
            data-uat={`a-ev-list-${componentPrefix}-event-info`}>

            {renderGameStateWrapper(event, componentPrefix, props.isDesktop, props.dict)}
            {renderTeamsWrapper(event, componentPrefix, props.showLeagueInEventCard)}

            {event.isLive
                ? renderLiveDetails(event, componentPrefix, props.dict)
                : renderPreliveDetails(event, componentPrefix)
            }
            {renderIconsWrapper(event, componentPrefix, props.dict, props.handlers, props.isDesktop)}
        </a>
    )
}
